(function () {
  const FILLER_UNITS = ["Playful Phantom", "Vanguard Sergeant", "Shipyard Skulker", "Mega-Mech"];
  const DEFAULT_BATTLEFIELD = "Aspirant's Climb";
  const DEFAULT_SEED = 7;

  function findCard(ref) {
    return RB.Setup.findCard(ref);
  }

  function legendForDomains(domains) {
    const legends = window.CARD_DB.filter(function (c) {
      return (c.types || []).indexOf("legend") >= 0;
    });
    const STATIC_KEYS = ["play", "auraMight", "auraMightSpecs", "auraKw", "auraKwSpecs",
      "auraUntargetable", "auraRestrictPlay", "auraEntersReady", "auraNoEnemyReady",
      "legendArm", "legendAdd", "costMod", "spellCostMod", "unitCostMod",
      "selfMight", "selfMightSpecs", "hideEnergyAlt", "victoryDelta", "tieRecallAll",
      "extraHideSlot", "addCosts", "repeatCosts", "entersReadyCond",
      "auraRepeatCosts", "auraUncounterable", "auraMinusMightBonus", "staticDeathReplace",
      "banishedWithPayoff", "addsBfToken", "restrictNamedSpell", "trashToBanish", "skipDrawPhase",
      "allowTrashPlay", "revealTriggers", "tokenDoubler", "deckRevealPeek", "moveTaxHere",
      "suppressTemporaryHere", "effectReplace", "auraAddCosts", "addResourceBonus"];
    const inert = legends.filter(function (l) {
      try {
        const s = RB.Scripts.build(l);
        if (s.unscripted || (s.triggers || []).length) return false;
        return STATIC_KEYS.every(function (k) {
          const v = s[k];
          return !v || (Array.isArray(v) && !v.length);
        });
      } catch (e) {
        return false;
      }
    });
    const pool = inert.length ? inert : legends;
    const want = (domains || []).filter(function (d) { return d !== "colorless"; });
    if (want.length) {
      const full = pool.find(function (l) {
        return want.every(function (d) { return (l.domains || []).indexOf(d) >= 0; });
      });
      if (full) return full;
      const partial = pool.find(function (l) {
        return want.some(function (d) { return (l.domains || []).indexOf(d) >= 0; });
      });
      if (partial) return partial;
    }
    return pool[0];
  }

  function championForDomains(domains) {
    const champs = window.CARD_DB.filter(RB.Decklists.isChampionUnit);
    const hit = champs.find(function (c) {
      return (c.domains || []).every(function (d) { return domains.indexOf(d) >= 0; });
    });
    return hit || champs[0];
  }

  function fillerDeck(n) {
    const out = [];
    for (let i = 0; i < n; i++) out.push(FILLER_UNITS[i % FILLER_UNITS.length]);
    return out;
  }

  function setupPlayer(name, domains, spec) {
    spec = spec || {};
    const legend = spec.legend ? findCard(spec.legend) : legendForDomains(domains);
    const runeDoms = (domains || []).filter(function (d) { return d !== "colorless"; });
    if (!runeDoms.length) runeDoms.push.apply(runeDoms, (legend.domains || ["fury"]).slice(0, 2));
    const champion = spec.champion ? findCard(spec.champion) : championForDomains(runeDoms);
    const runes = [];
    if (spec.runeDeck) {
      for (const ref of spec.runeDeck) {
        runes.push(RB.Decklists.RUNE_CARDS[ref] || ref);
      }
    } else {
      for (let i = 0; i < 12; i++) {
        runes.push(RB.Decklists.RUNE_CARDS[runeDoms[i % runeDoms.length]]);
      }
    }
    return {
      name: name,
      legend: legend.id,
      champion: champion.id,
      deck: spec.deck ? spec.deck.slice() : fillerDeck(spec.deckSize || 20),
      runes: runes,
      battlefields: [spec.battlefield || DEFAULT_BATTLEFIELD],
    };
  }

  function lastStaged(state, ref, p) {
    const want = findCard(ref);
    let hit = null;
    for (const iid in state.objs) {
      const o = state.objs[iid];
      if (!o || o.zone !== "board" || o.controller !== p) continue;
      if (want ? o.card === want.id : RB.Core.name(state, iid) === ref) hit = iid;
    }
    return hit;
  }

  function attachAction(state, a) {
    const gear = lastStaged(state, a.gear, a.player);
    const host = lastStaged(state, a.host, a.player);
    if (!gear) throw new Error("scenario: no staged " + a.gear + " to attach");
    if (!host) throw new Error("scenario: no staged " + a.host + " to attach " + a.gear + " to");
    return { type: "MANUAL", op: "attach", args: { iid: gear, host: host } };
  }

  function resolveLoc(state, loc, p) {
    if (!loc || loc === "base") return { t: "base", p: p };
    const m = String(loc).match(/^bf(\d)$/);
    if (m) {
      const bf = state.battlefields[+m[1]];
      if (!bf) throw new Error("scenario: no battlefield " + loc);
      return { t: "bf", iid: bf };
    }
    return loc;
  }

  function stagePlayer(actions, state, p, side) {
    if (!side) return;
    for (const ref of side.hand || []) {
      actions.push({ type: "MANUAL", op: "put", args: { card: ref, player: p, zone: "hand" } });
    }
    for (const u of side.board || []) {
      const args = {
        card: u.card, player: p, zone: "board",
        dest: resolveLoc(state, u.loc, p),
        ready: true,
      };
      if (u.buffs) args.buffs = u.buffs;
      actions.push({ type: "MANUAL", op: "put", args: args });
      if (u.attachTo) actions.push({ type: "ATTACH_STAGED", gear: u.card, host: u.attachTo, player: p });
      if (u.ready === false) actions.push({ type: "EXHAUST_STAGED", card: u.card, player: p });
    }
    for (const f of side.facedown || []) {
      const dest = resolveLoc(state, f.loc || f.bf, p);
      actions.push({
        type: "MANUAL", op: "put",
        args: { card: f.card, player: p, zone: "facedown", dest: dest },
      });
    }
    for (const ref of side.trash || []) {
      actions.push({ type: "MANUAL", op: "put", args: { card: ref, player: p, zone: "trash" } });
    }
    if (side.points) actions.push({ type: "MANUAL", op: "points", args: { player: p, n: side.points } });
    if (side.xp) actions.push({ type: "MANUAL", op: "xp", args: { player: p, n: side.xp } });
  }

  function stagePiles(actions, p, side) {
    if (!side) return;
    if (side.runeTop) actions.push({ type: "MANUAL", op: "runeOrder", args: { player: p, top: side.runeTop } });
    if (side.deckTop) actions.push({ type: "MANUAL", op: "deckTop", args: { player: p, top: side.deckTop } });
  }

  function preludeStep(game, state, picks) {
    const pd = state.pending;
    const acts = RB.Enum.actions(state);
    let a = null;
    if (picks.length) {
      const want = String(picks[0]).toLowerCase();
      a = acts.find(function (x) {
        if (x.type !== "CHOOSE") return false;
        if (x.optionIdx !== undefined) {
          const label = String((pd.options || [])[x.optionIdx] || "").toLowerCase();
          return label === want || (want === "yes" && x.optionIdx === 0) || (want === "no" && x.optionIdx === 1);
        }
        return (x.picks || []).some(function (c) {
          if (state.objs[c]) return RB.Core.name(state, c).toLowerCase() === want;
          if (c && c.t === "bf") return want === "bf" + state.battlefields.indexOf(c.iid);
          if (c && c.t === "base") return want === "base";
          return false;
        });
      }) || null;
      if (a) picks.shift();
    }
    if (!a && pd.kind === "assign") {
      let best = null, most = -1;
      for (const x of acts) {
        if (x.type !== "ASSIGN") continue;
        let sum = 0;
        for (const k in x.dist) sum += x.dist[k];
        if (sum > most) { most = sum; best = x; }
      }
      a = best;
    }
    if (!a) {
      a = acts.find(function (x) { return x.type === "PAY"; }) ||
        acts.find(function (x) { return x.type === "CHOOSE"; }) ||
        acts.find(function (x) { return x.type === "PASS"; }) ||
        acts.find(function (x) { return x.type === "CONTINUE"; }) ||
        acts.find(function (x) { return x.type === "END_TURN"; });
    }
    if (!a) throw new Error("scenario prelude stuck at " + pd.kind);
    const r = Kernel.dispatch(game, state, a);
    if (!r.ok) throw new Error("scenario prelude failed: " + r.error);
    return r.state;
  }

  const Scenario = {
    settleTo(game, state, picks, stop) {
      let guard = 0;
      while (state.pending && guard++ < 200) {
        if (stop(state, state.pending)) return state;
        state = preludeStep(game, state, picks);
      }
      return state;
    },

    runPrelude(game, state, steps, picks) {
      picks = picks.slice();
      const atAct = function (who) {
        return function (st, pd) { return pd.kind === "act" && pd.player === who; };
      };
      let halt = false;
      for (const step of steps) {
        if (step.endTurn) {
          state = Scenario.settleTo(game, state, picks, atAct(state.turn.player));
          const a = RB.Enum.actions(state).find(function (x) { return x.type === "END_TURN"; });
          if (!a) throw new Error("scenario prelude: cannot end turn");
          const r = Kernel.dispatch(game, state, a);
          if (!r.ok) throw new Error("scenario prelude: " + r.error);
          state = r.state;
        } else if (step.move !== undefined) {
          const who = step.p === undefined ? 0 : step.p;
          state = Scenario.settleTo(game, state, picks, atAct(who));
          const iid = Object.keys(state.objs).find(function (i) {
            const o = state.objs[i];
            return o && o.zone === "board" && o.controller === who && RB.Core.name(state, i) === step.move;
          });
          if (!iid) throw new Error("scenario prelude: " + step.move + " not on p" + who + "'s board");
          const dest = step.to === "base" ? null : state.battlefields[step.to];
          const a = RB.Enum.actions(state).find(function (x) {
            if (x.type !== "STANDARD_MOVE" || x.units[0] !== iid) return false;
            return dest ? (x.dest.t === "bf" && x.dest.iid === dest) : x.dest.t === "base";
          });
          if (!a) throw new Error("scenario prelude: cannot move " + step.move);
          const r = Kernel.dispatch(game, state, a);
          if (!r.ok) throw new Error("scenario prelude: " + r.error);
          state = r.state;
        } else if (step.toPlayer !== undefined) {
          state = Scenario.settleTo(game, state, picks, atAct(step.toPlayer));
        } else if (step.stopAt !== undefined) {
          state = Scenario.settleTo(game, state, picks, function (st, pd) { return pd.kind === step.stopAt; });
          halt = true;
        } else if (step.settle) {
          state = Scenario.settleTo(game, state, picks, function (st, pd) { return pd.kind === "act"; });
        }
      }
      if (halt) return state;
      return Scenario.settleTo(game, state, picks, function (st, pd) { return pd.kind === "act"; });
    },

    buildGame(spec) {
      spec = spec || {};
      const under = spec.underTest ? findCard(spec.underTest) : null;
      if (spec.underTest && !under) throw new Error("scenario: card not found " + spec.underTest);
      if (under && (under.types || []).indexOf("legend") >= 0) {
        spec = Object.assign({}, spec, {
          legend: spec.legend || under.id,
          copies: spec.copies !== undefined ? spec.copies : 0,
        });
      }
      const domains = (under && under.domains) || ["fury"];
      const setup = {
        seed: spec.seed !== undefined ? spec.seed : DEFAULT_SEED,
        firstPlayer: 0,
        ai: [false, false],
        players: [
          setupPlayer("Tester", domains, Object.assign({}, spec.p0, spec)),
          setupPlayer("Sparring", domains, spec.p1 || {}),
        ],
      };
      const game = Kernel.newGame(setup);
      let state = Kernel.computeState(game, 0);
      const fire = function (a) {
        const r = Kernel.dispatch(game, state, a);
        if (!r.ok) throw new Error("scenario staging failed: " + r.error);
        state = r.state;
      };

      const staging = [];
      const pools = [];
      if (!spec.keepDealtHand) {
        for (let p = 0; p < 2; p++) {
          for (const iid of state.players[p].hand.slice()) {
            staging.push({ type: "MANUAL", op: "recycle", args: { iid: iid } });
          }
        }
      }
      const copies = spec.copies !== undefined ? spec.copies : 2;
      const underIsLegend = !!under && (under.types || []).indexOf("legend") >= 0;
      if (under && !underIsLegend) {
        const dest = spec.underTestZone || "hand";
        if (dest === "hand") {
          for (let i = 0; i < copies; i++) {
            staging.push({ type: "MANUAL", op: "put", args: { card: under.id, player: 0, zone: "hand" } });
          }
        } else {
          staging.push({
            type: "MANUAL", op: "put",
            args: { card: under.id, player: 0, zone: "board", dest: resolveLoc(state, spec.underTestLoc, 0) },
          });
        }
      }
      for (let p = 0; p < 2; p++) {
        const side = (p === 0 ? spec.p0 : spec.p1) || {};
        const handCards = [];
        if (p === 0 && under && !underIsLegend && (spec.underTestZone || "hand") === "hand") {
          for (let i = 0; i < copies; i++) handCards.push(under);
        }
        for (const ref of side.hand || []) {
          const c = findCard(ref);
          if (c) handCards.push(c);
        }
        if (side.energy !== undefined) {
          pools.push({ type: "MANUAL", op: "energy", args: { player: p, n: side.energy } });
        }
        if (side.power) {
          for (const d in side.power) {
            pools.push({ type: "MANUAL", op: "power", args: { player: p, domain: d, n: side.power[d] } });
          }
        }
        if (side.runes === undefined) {
          if (handCards.length && side.energy === undefined && !side.power) {
            const perDomain = {};
            let energy = 0;
            for (const c of handCards) {
              energy += c.energy || 0;
              const pips = c.power || 0;
              const doms = (c.domains || []).filter(function (d2) { return d2 !== "colorless"; });
              if (pips && doms.length) perDomain[doms[0]] = (perDomain[doms[0]] || 0) + pips;
              for (const d of doms) perDomain[d] = perDomain[d] || 0;
            }
            const domList = Object.keys(perDomain);
            if (domList.length) {
              let total = energy + 1;
              for (const d of domList) total += perDomain[d];
              total = Math.min(14, total);
              const runeList = [];
              for (const d of domList) {
                for (let i = 0; i < perDomain[d]; i++) runeList.push(d);
              }
              let i = 0;
              while (runeList.length < total) runeList.push(domList[i++ % domList.length]);
              for (const d of runeList) {
                staging.push({
                  type: "MANUAL", op: "put",
                  args: { card: RB.Decklists.RUNE_CARDS[d], player: p, zone: "board" },
                });
              }
            }
          }
        } else {
          for (const d in side.runes) {
            for (let i = 0; i < side.runes[d]; i++) {
              staging.push({
                type: "MANUAL", op: "put",
                args: { card: RB.Decklists.RUNE_CARDS[d], player: p, zone: "board" },
              });
            }
          }
        }
      }
      const boardActions = [];
      stagePlayer(boardActions, state, 0, spec.p0);
      stagePlayer(boardActions, state, 1, spec.p1);

      const exhausts = [];
      for (const a of staging) fire(a);
      for (const a of boardActions) {
        if (a.type === "ATTACH_STAGED") { fire(attachAction(state, a)); continue; }
        if (a.type === "EXHAUST_STAGED") {
          const iid = lastStaged(state, a.card, a.player);
          if (!iid) throw new Error("scenario: no staged " + a.card + " to exhaust");
          exhausts.push({ type: "MANUAL", op: "exhaust", args: { iid: iid } });
          continue;
        }
        fire(a);
      }

      let guard = 0;
      while (state.pending && state.pending.kind === "mulligan" && guard++ < 4) {
        fire({ type: "MULLIGAN", player: state.pending.player, cards: [] });
      }

      const underId = under ? under.id : null;
      const chainInvolvesUnderTest = function (st) {
        if (!underId) return false;
        return st.chain.some(function (it) {
          const src = it.source && st.objs[it.source];
          const own = it.iid && st.objs[it.iid];
          return (src && src.card === underId) || (own && own.card === underId);
        });
      };
      const prelude = spec.prelude || [];
      const picks = (spec.preludePicks || []).slice();
      let openGuard = 0;
      while (!prelude.length && state.pending && state.pending.kind !== "act" &&
        state.pending.kind !== "manual" && !chainInvolvesUnderTest(state) && openGuard++ < 80) {
        state = preludeStep(game, state, picks);
      }

      stagePiles(pools, 0, spec.p0);
      stagePiles(pools, 1, spec.p1);
      if (pools.length && state.turn.phase !== "main") {
        throw new Error("scenario: energy/power staging would be wiped by the main-phase pool reset because " +
          "this scenario opens inside a beginning-phase window - stage 'runes' instead");
      }
      for (const a of pools) fire(a);
      for (const a of exhausts) fire(a);

      if (prelude.length) state = Scenario.runPrelude(game, state, prelude, picks);

      return { game: game, state: state };
    },
  };

  window.RB = window.RB || {};
  window.RB.Scenario = Scenario;
})();
